import React from 'react';
import SvgIcon from './SvgIcon';

/**
 * @param {FF.SvgIcon} props
 */
function SubstituteIcon(props) {
  return (
    <SvgIcon viewBox="0 0 24 24" {...props}>
      <title>Substitute</title>
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6 11.9994V14.9994H21V17.0004H6V20.0004L2 16.0004L6 11.9994ZM18.0002 3.99982L22.0002 8.00082L18.0002 11.9998V8.99982H3.0002V7.00082H18.0002V3.99982Z"
        />
      </g>
    </SvgIcon>
  );
}

export default SubstituteIcon;
